/**
 * =========================================================================================
 * Sidebar collapse state - persistence
 * =========================================================================================
 * Shared by USidebarV2 and by every product layout that drives it in controlled mode, so the
 * storage key format and the "never seen before" fallback stay in one place.
 *
 * `fallback` is what a product looked like BEFORE USidebarV2 existed: products whose sidebar was
 * the 90px icon rail pass `true`, payroll (already a wide sidebar) passes `false`. That keeps the
 * first render after the upgrade identical to what the user had, and from then on their own
 * choice in storage wins.
 **/

export const readCollapsed = (key, fallback = false) => {
    if (!key) return fallback;
    try {
        const stored = window.localStorage.getItem(key);
        return stored === null ? fallback : stored === '1';
    } catch (e) {
        return fallback;
    }
};

export const writeCollapsed = (key, collapsed) => {
    if (!key) return;
    try {
        window.localStorage.setItem(key, collapsed ? '1' : '0');
    } catch (e) {
        /* storage unavailable */
    }
};
